
import { ChevronDownIcon, TriangleDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { lopApi } from '../../api/lopApi';
import { crmLopApi } from '../../api/crmLopApi';
import { useCommonContext } from '../../contexts/common';
import { dm_lop_viewmodel } from '../../models/response/dm-lop/dm_lop';
type ComboboxLopProps = {
	isReadonly?: boolean;
	disabled?: boolean;
	value?: number;
	ignore_id?: number;
	onValueChanged: (id: number, data?: dm_lop_viewmodel) => void;
	className?: string;
	preText?: string;
	width?: string | number;
	dm_khoi_id?: number;
	dm_truong_id?: number;
	dm_he_id?: number;
	nam_hoc?: string;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
	isShowClearBtn?: boolean,
	maxWidth?: any
};
const ComboboxLop = (props: ComboboxLopProps) => {
	const { translate } = useCommonContext();
	const [lops, setLops] = useState<dm_lop_viewmodel[]>([]);
	const handleReloadLops = async () => {
		try {
			let res;

			// Thử cách 1: Sử dụng SelectByNamHoc nếu có năm học
			if (props.nam_hoc) {
				console.log('ComboboxLop - Using SelectByNamHoc API:', props.nam_hoc);
				res = await lopApi.SelectByNamHoc(props.nam_hoc);

				// Nếu không có dữ liệu, thử crmLopApi.selectAll
				if (!res.is_success || !res.data || res.data.length === 0) {
					console.log('ComboboxLop - SelectByNamHoc failed, trying crmLopApi.selectAll');
					res = await crmLopApi.selectAll();
				}
			} else {
				// Thử crmLopApi.selectAll nếu không có năm học
				console.log('ComboboxLop - No nam_hoc, using crmLopApi.selectAll');
				res = await crmLopApi.selectAll();
			}

			console.log('ComboboxLop - API Response:', res);

			if (res.is_success) {
				setLops(res.data || []);
				console.log('ComboboxLop - Lops loaded:', res.data?.length || 0, 'items');
			} else {
				console.warn('ComboboxLop - All APIs failed:', res.message);
				setLops([]);
			}
		} catch (error) {
			console.error('ComboboxLop - Error loading lops:', error);
			setLops([]);
		}
	};

	// Load dữ liệu ngay khi component mount
	useEffect(() => {
		handleReloadLops();
	}, []);

	// Reload khi props thay đổi
	useEffect(() => {
		handleReloadLops();
	}, [props.nam_hoc, props.dm_truong_id, props.dm_khoi_id, props.dm_he_id]);

	const lopFilters: dm_lop_viewmodel[] = useMemo(() => {
		const ignore_id = props.ignore_id || 0;
		if (!lops || lops.length === 0) {
			console.log('ComboboxLop - No lops data available');
			return [];
		}

		console.log('ComboboxLop - Filtering lops:', {
			totalLops: lops.length,
			props: {
				nam_hoc: props.nam_hoc,
				dm_truong_id: props.dm_truong_id,
				dm_khoi_id: props.dm_khoi_id,
				dm_he_id: props.dm_he_id,
				ignore_id: props.ignore_id
			}
		});

		if (!props.nam_hoc) return [];
		if (!props.dm_he_id || props.dm_he_id <= 0 || !props.dm_khoi_id || props.dm_khoi_id <= 0 || !props.dm_truong_id || props.dm_truong_id <= 0) {
			return [];
		}

		const filtered = lops.filter((x) => {
			if (x.id === ignore_id) return false;
			if (x.nam_hoc !== props.nam_hoc) return false;
			if (props.dm_truong_id && props.dm_truong_id > 0 && x.dm_truong_id !== props.dm_truong_id) return false;
			if (props.dm_khoi_id && props.dm_khoi_id > 0 && x.dm_khoi_id !== props.dm_khoi_id) return false;
			if (props.dm_he_id && props.dm_he_id > 0 && x.dm_he_id !== props.dm_he_id) return false;

			return true;
		}).sort((a, b) => (a.ten_lop > b.ten_lop) ? 1 : -1);

		console.log('ComboboxLop - Filtered result:', filtered.length, 'items');
		return filtered;
	}, [lops, props.dm_truong_id, props.nam_hoc, props.dm_khoi_id, props.dm_he_id, props.ignore_id]);
	const [filter, setFilter] = useState('')
	const [open, setOpen] = useState(false)
	const dataSource = useMemo(() => {
		return lopFilters.map(x => {
			const item: any = {
				id: x.id,
				text: x.ten_lop,
			}
			return item;
		})
	}, [lopFilters])
	const filterdData = useMemo(() => {
		return dataSource.filter(item =>
			item.text.toLowerCase().includes(filter.toLowerCase())
		)
	}, [dataSource, filter])
	const _selectedData = useMemo(() => {
		return dataSource.find(item => item.id === props.value)
	}, [props.value, dataSource])
	return (
		<SelectPanel
			renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
				<Button
					disabled={props.disabled || props.isReadonly || !props.dm_he_id || props.dm_he_id <= 0 || !props.dm_khoi_id || props.dm_khoi_id <= 0 || !props.dm_truong_id || props.dm_truong_id <= 0}
					sx={{
						width: '100%', 
						overflow: 'hidden', 
						whiteSpace: 'nowrap', 
						textOverflow: 'ellipsis' 
					}}
					className='button-left'
					 trailingAction={ChevronDownIcon}
					aria-labelledby={` ${ariaLabelledBy}`}
					{...anchorProps}
				>
					<p
						style={{
							width: '100%',
							overflow: 'hidden',
							whiteSpace: 'nowrap',
							textOverflow: 'ellipsis'
						}}
					>
						{children || translate(`ComboboxLop.PlaceHolder`)}
					</p>
				</Button>
			)}
			title={
				<>
					<Box sx={{ display: 'flex', alignItems: 'center' }}>
						<Box sx={{ flex: 1 }}>
							{translate(`ComboboxLop.PlaceHolder`)} ({filterdData.length} items)
						</Box>
						{props.isShowClearBtn && (props.value ?? 0) > 0 && (
							<Button
								trailingVisual={XCircleFillIcon}
								variant="invisible"
								sx={{
									color: 'danger.emphasis'
								}}
								onClick={() => {
									props.onValueChanged(0);
								}}
							>
								Bỏ chọn
							</Button>
						)}
					</Box>
				</>
			}
			placeholderText="Search"
			open={open}
			onOpenChange={setOpen}
			items={filterdData}
			selected={_selectedData}
			onSelectedChange={(data: any) => {
				if (data) {
					const selectedLop = lopFilters.find(x => x.id === data.id) || lops.find(x => x.id === data.id);
					props.onValueChanged(data.id, selectedLop);
				}
			}}
			onFilterChange={setFilter}
			showItemDividers={true}
			overlayProps={{
				width: 'medium',
				height: 'medium'
			}}
		/>


	);
};

export default ComboboxLop;
